<template>
  <v-card class="pa-4">
    <component
      :is="makeBlockComponentName(block.type)"
      v-for="block in blocks"
      :key="block.id"
      :data="block"
      :possible-next="possibleSubs"
      :is-last="blocks.indexOf(block) === blocks.length - 1"
      @edit="editBlock"
      @remove="removeBlock"
      @create="createSub"
      @move="moveBlock"
    />
    <v-divider v-if="blocks.length"></v-divider>
    <v-toolbar class="block-control" flat elevation="0">
      <v-menu offset-y>
        <template #activator="{ on, attrs }">
          <v-btn
            color="success"
            fab
            small
            v-bind="attrs"
            title="Добавить блок"
            v-on="on"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(text, type) in possibleSubs"
            :key="type"
            @click="create(type, -2)"
          >
            <v-list-item-title>{{ text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
  </v-card>
</template>

<script>
import BlockTitle from "./blocks/BlockTitle";
import BlockImage from "./blocks/BlockImage";
import BlockText from "./blocks/BlockText";
import BlockCover from "./blocks/BlockCover";
import BlockH2 from "./blocks/BlockH2";
import BlockImageText from "./blocks/BlockImageText";
import BlockYoutube from "./blocks/BlockYoutube";

export default {
  name: "ContentBlocks",
  components: {
    BlockTitle,
    BlockCover,
    BlockH2,
    BlockText,
    BlockImage,
    BlockImageText,
    BlockYoutube
  },
  props: {
    blocks: {
      type: Array,
      default() {
        return [];
      }
    },
    id: {
      type: Number,
      required: true
    },
    lang: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      possibleSubs: {
        h2: "Подзаголовок",
        text: "Текст",
        image: "Изображение",
        'image-text': "Изображение с текстом",
        youtube: "YouTube видео"
      }
    };
  },
  methods: {
    create(type, after) {
      this.$emit("read", {
        type,
        article_id: this.id,
        lang:this.lang,
        after
      });
    },
    createSub(payload) {
      this.$emit("read", payload);
    },
    makeBlockComponentName(type) {
      type = this.camelize(type);
      return "Block" + type.charAt(0).toUpperCase() + type.substr(1);
    },
    camelize(string) {
      return string.replace(/-./g, (x) => x[1].toUpperCase());
    },
    editBlock(block) {
      this.$emit("read", block);
    },
    removeBlock(block) {
      this.$emit("remove", block);
    },
    moveBlock(block, dir) {
      this.$emit("move", block, dir);
    }
  }
};
</script>

<style lang="scss">
.block-control .v-toolbar__content {
  justify-content: center;
}
</style>
